<div class="flex items-center justify-between gap-2 border-b border-line px-3 py-2">
  <span class="text-xs font-semibold uppercase tracking-wide text-muted">Conversas</span>
  <button appButton size="sm" variant="primary" (click)="contactSearchOpen.set(true)">
    <ng-icon name="heroPlus" size="14" />
    Nova conversa
  </button>
</div>

<label class="relative block border-b border-line px-3 py-2">
  <span class="sr-only">Buscar conversas</span>
  <ng-icon
    name="heroMagnifyingGlass"
    size="16"
    aria-hidden="true"
    class="pointer-events-none absolute left-6 top-1/2 z-[1] -translate-y-1/2 text-muted"
  />
  <input
    appInput
    leadingIcon
    surface="transparent"
    type="search"
    aria-label="Buscar conversas"
    placeholder="Buscar por contato ou mensagem"
    [value]="searchValue()"
    (input)="onSearchInput($any($event.target).value)"
  />
</label>

<div class="conversation-list__scroll min-h-0 flex-1 overflow-y-auto p-2">
  @if (store.isLoadingConversations()) {
    <app-ui-skeleton-grid [rows]="5" [rowHeight]="132" />
  } @else {
    @for (conversation of filters.conversations(); track conversation.id) {
      <div class="conversation-row-wrapper">
        <button
          appUiRecordRowButton
          type="button"
          class="conversation-row w-full rounded-md p-3 text-left transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/30"
          [class.conversation-row--active]="store.selectedConversationId() === conversation.id"
          (click)="selectConversation(conversation.id)"
        >
          <span class="flex items-start justify-between gap-3">
            <span class="min-w-0">
              <span class="flex min-w-0 items-baseline gap-1.5">
                <span class="truncate text-sm font-semibold text-ink">{{ conversation.contact }}</span>
                @if (conversation.company) {
                  <span appUiHint class="truncate">· {{ conversation.company }}</span>
                }
              </span>
              <span appUiHint class="mt-1 flex min-w-0 items-center gap-1.5">
                <app-channel-icon [channel]="conversation.channel" />
                <span class="truncate">{{ conversation.channelIdentity }}</span>
              </span>
            </span>
            <span class="flex shrink-0 items-center gap-1">
              @if (conversation.unread > 0) {
                <span appBadge tone="accent" size="sm" class="conversation-row__unread-count">
                  {{ conversation.unread }}
                </span>
              } @else if (conversation.manuallyUnread) {
                <app-ui-pulse-dot [sizeRem]="0.625" title="Marcada como não lida" aria-label="Não lida" />
              }
            </span>
          </span>

          <span class="conversation-row__message mt-2 block text-muted">{{ conversation.lastMessage || 'Sem mensagens ainda.' }}</span>

          <span class="conversation-row__meta mt-3 flex items-center gap-1.5">
            <span class="conversation-row__pills">
              <span appBadge tone="neutral" size="xs" class="conversation-row__pill">
                {{ statusLabel(conversation.status) }}
              </span>
              <span
                appBadge
                size="xs"
                class="conversation-row__pill"
                [tone]="priorityTone(conversation.priority)"
              >{{ priorityLabel(conversation.priority) }}</span>
              @if (conversation.labels.length > 0) {
                <span class="conversation-row__divider" aria-hidden="true"></span>
                @for (label of conversation.labels; track label.id) {
                  <span
                    appBadge
                    tone="neutral"
                    size="xs"
                    class="conversation-row__label"
                    [style.color]="label.color"
                  >
                    <ng-icon name="heroTag" size="11" aria-hidden="true" />
                    {{ label.name }}
                  </span>
                }
              }
            </span>
            <span appUiLabel class="conversation-row__time">{{ conversation.lastMessageAt }}</span>
          </span>
        </button>

        <!-- Context menu (3-dot button): shown on hover of the wrapper -->
        <div class="conversation-row__actions">
          <button
            type="button"
            appUiIconButton
            variant="ghost"
            size="xs"
            [ngpMenuTrigger]="conversationRowMenu"
            ngpMenuTriggerPlacement="bottom-end"
            [attr.aria-label]="'Opções para ' + conversation.contact"
            (click)="$event.stopPropagation()"
          >
            <ng-icon name="heroEllipsisHorizontal" size="14" aria-hidden="true" />
          </button>

          <ng-template #conversationRowMenu>
            <div appMenuPanel class="conversation-row__dropdown" role="menu">
              @if (conversation.unread > 0 || conversation.manuallyUnread) {
                <button type="button" appMenuItem role="menuitem" (click)="onMenuMarkAsRead(conversation.id, $event)">
                  Marcar como lida
                </button>
              } @else {
                <button type="button" appMenuItem role="menuitem" (click)="onMenuMarkAsUnread(conversation.id, $event)">
                  Marcar como não lida
                </button>
              }
            </div>
          </ng-template>
        </div>
      </div>
    } @empty {
      <app-ui-empty-state
        compact
        title="Nenhuma conversa encontrada"
        description="Ajuste os filtros ou a busca para localizar conversas já carregadas."
      />
    }
  }
</div>

@if (contactSearchOpen()) {
  <app-contact-search-dialog (selected)="onContactPicked($event)" (dismissed)="contactSearchOpen.set(false)" />
}

@if (startForContactId(); as contactId) {
  <app-iniciar-conversa-dialog [contactId]="contactId" (dismissed)="startForContactId.set(null)" />
}
